import cx from 'classnames';
import s from './NewTabLink.module.scss';
import { IconArrowTo } from '@/shared/ui/Icons';
import Link from 'next/link';

type NewTabLinkProps = {
  href?: string;
  className?: string;
}

const NewTabLink = (props: NewTabLinkProps) => {
  const {
    href = '',
    className = '',
  } = props;

  return (
    href ? (
      <Link href={href} target='_blank' className={cx(s.root, className)}>
        <IconArrowTo className="text-white/[0.6]"/>
      </Link>
    ): 
    <span className={cx(s.root, className)}>
      <IconArrowTo className="text-white/[0.6]"/>
    </span>
  );
}

export default NewTabLink;
